import { Component, Input, ViewEncapsulation } from '@angular/core';
import { HxErrorHandlerService } from '../../services/error-handler.service';
import { HxCallcenterService } from 'hx-services';
import { NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-call-audio',
    templateUrl: './call-audio.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, TranslocoPipe]
})
export class HxCallAudioComponent {

  @Input() callId?: string;

  callUrl?: string;

  constructor(
    private callcenterService: HxCallcenterService,
    private errorService: HxErrorHandlerService
  ) {
  }

  async play() {
    if (this.callId) {
      try {
        const data = await this.callcenterService.getCallUrlById(this.callId);
        this.callUrl = data.url;
      } catch (err: any) {
        this.errorService.check(err?.error);
      }
    }
  }

}
